import { makeActionCreator } from "../utils/reduxUtils";
import API from "../utils/API";

export const INIT_AUTH_DATA = "INIT_AUTH_DATA";
export const initAuthData = makeActionCreator(INIT_AUTH_DATA);